/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Short_AInputs */



/**
* | output |
* | --- |
* | "When a customer's billing restarts — for example when a suspended customer is restored, or a customer returns from the Free plan to a paid plan — the next bi..." |
*
* @param {Partner_Faq_Short_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_short_a = /** @type {((inputs?: Partner_Faq_Short_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Short_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn die Abrechnung eines Kunden neu beginnt — zum Beispiel, wenn ein gesperrter Kunde entsperrt wird oder ein Kunde vom Free-Tarif zu einem bezahlten Tarif zurückkehrt —, läuft die nächste Abrechnung nur von diesem Tag bis zu seinem gewohnten Abrechnungstag. Sie zahlen nur für die Tage, die die Abrechnung umfasst.")
	return /** @type {LocalizedString} */ ("When a customer's billing restarts — for example when a suspended customer is restored, or a customer returns from the Free plan to a paid plan — the next bill runs only from that day to their usual billing day. You only pay for the days the bill covers.")
});